/**
 * Normalize UI / form values before writing UUID columns.
 * Postgres rejects empty string ("") for uuid — use null instead.
 */

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const UUID_SENTINELS = new Set(["", "none", "null", "undefined"]);

export function toNullableUuid(value) {
  if (value == null) {
    return null;
  }

  const trimmed = String(value).trim();
  return trimmed === "" ? null : trimmed;
}

export function isUuidString(value) {
  if (value == null) {
    return false;
  }
  const trimmed = String(value).trim();
  if (UUID_SENTINELS.has(trimmed.toLowerCase())) {
    return false;
  }
  return UUID_RE.test(trimmed);
}

/**
 * Require a real UUID for tenant-scoped writes. Rejects empty string, "none",
 * and other non-UUID sentinels that Postgres would otherwise coerce poorly.
 */
export function requireUuid(value, fieldName = "id") {
  if (!isUuidString(value)) {
    throw new Error(`${fieldName} is required.`);
  }
  return String(value).trim();
}
